import { Flag } from 'src/app-components/Flag'

import { CircleDollarSign, ClipboardText } from '@fsg/icons'

import { LeadResponse, OpportunityResponse } from '@app/types'
import { routes } from '@app/utils/routes'

import { formatDateAsMMDDYY } from '../utils/formatDateAsMMDDYY'
import { SalesListItem } from './SalesListItem'

type ItemStatus = 'scheduled' | 'pastDue' | 'hot' | 'stale'

type TypedEntity<T> = T & {
  entityType: string
}

function renderItem(status: ItemStatus) {
  // eslint-disable-next-line react/display-name
  return (item: TypedEntity<LeadResponse | OpportunityResponse>) => {
    const isLead = item.entityType === 'lead'

    const getLeadProps = (item: LeadResponse) => {
      const date = formatDateAsMMDDYY(item.nextFollowUp)
      const tertiary = status === 'pastDue' ? <Flag label={date} color="red" /> : date

      return {
        primary: item.fullName,
        secondary: item.companyName,
        tertiary,
        icon: ClipboardText,
        href: routes.lead.general(item.id),
      }
    }

    const getOppProps = (item: OpportunityResponse) => {
      const date = formatDateAsMMDDYY(item.nextFollowUp)
      const tertiary = status === 'pastDue' ? <Flag label={date} color="red" /> : date

      return {
        primary: item.name,
        secondary: item.account.name,
        tertiary,
        icon: CircleDollarSign,
        href: routes.opportunity.basicInformation(item.id),
      }
    }

    const props = isLead ? getLeadProps(item as LeadResponse) : getOppProps(item as OpportunityResponse)

    return <SalesListItem key={item.id} {...props} />
  }
}

export const renderScheduledItem = renderItem('scheduled')
export const renderPastDueItem = renderItem('pastDue')
export const renderHotItem = renderItem('hot')
export const renderStaleItem = renderItem('stale')
